var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinbookLogoNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 86,
    viewBox: "0 0 224 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.416%",
    y1: "41.693%",
    x2: "134.123%",
    y2: "75.266%",
    id: "988okwrpxc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#033898",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "88.866%",
    y1: "22.619%",
    x2: "26.145%",
    y2: "76.499%",
    id: "4qp7rrr7wd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5AE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "80.377%",
    x2: "87.442%",
    y2: "34.711%",
    id: "w6omsa2fie"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5AE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-28.1%",
    y: "-23.4%",
    width: "156.2%",
    height: "156.2%",
    filterUnits: "objectBoundingBox",
    id: "sbpgz3wi8a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.074847028 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "56dgue9x5b",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.3 33.436c.544 0 .85-.306.85-.85V29.05c0-.544-.306-.85-.85-.85H93.89c-.544 0-.85.306-.85.85v22.1c0 .544.306.85.85.85h3.74c.544 0 .85-.306.85-.85v-7.548h7.65c.544 0 .85-.306.85-.85v-3.536c0-.544-.306-.85-.85-.85h-7.65v-4.93h7.82zM110.182 32.96h3.4c.544 0 .85-.306.85-.85v-3.06c0-.544-.306-.85-.85-.85h-3.4c-.544 0-.85.306-.85.85v3.06c0 .544.306.85.85.85zm0 19.04h3.4c.544 0 .85-.306.85-.85v-15.3c0-.544-.306-.85-.85-.85h-3.4c-.544 0-.85.306-.85.85v15.3c0 .544.306.85.85.85zM126.983 34.524c-2.173 0-3.62.847-4.42 2.029v-.703c0-.544-.306-.85-.85-.85h-3.4c-.544 0-.85.306-.85.85v15.3c0 .544.306.85.85.85h3.4c.544 0 .85-.306.85-.85v-9.078c0-2.006.952-2.856 2.482-2.856 1.292 0 2.278.748 2.278 2.448v9.486c0 .544.306.85.85.85h3.4c.544 0 .85-.306.85-.85v-9.928c0-4.25-2.278-6.698-5.44-6.698zM145.179 34.524c-2.275 0-3.929.768-5.066 2.064V29.05c0-.544-.306-.85-.85-.85h-3.4c-.544 0-.85.306-.85.85v22.1c0 .544.306.85.85.85h3.4c.544 0 .85-.306.85-.85v-.738c1.137 1.296 2.791 2.064 5.066 2.064 4.454 0 8.126-3.91 8.126-8.976 0-5.066-3.672-8.976-8.126-8.976zm-1.02 13.124c-2.346 0-4.046-1.598-4.046-4.148s1.7-4.148 4.046-4.148 4.046 1.598 4.046 4.148-1.7 4.148-4.046 4.148zM163.647 52.476c4.998 0 9.01-3.91 9.01-8.976 0-5.066-4.012-8.976-9.01-8.976s-9.01 3.91-9.01 8.976c0 5.066 4.012 8.976 9.01 8.976zm0-4.964c-2.21 0-3.91-1.598-3.91-4.012 0-2.414 1.7-4.012 3.91-4.012s3.91 1.598 3.91 4.012c0 2.414-1.7 4.012-3.91 4.012zM182.998 52.476c4.998 0 9.01-3.91 9.01-8.976 0-5.066-4.012-8.976-9.01-8.976s-9.01 3.91-9.01 8.976c0 5.066 4.012 8.976 9.01 8.976zm0-4.964c-2.21 0-3.91-1.598-3.91-4.012 0-2.414 1.7-4.012 3.91-4.012s3.91 1.598 3.91 4.012c0 2.414-1.7 4.012-3.91 4.012zM209.422 50.98l-5.27-7.48 4.998-7.48c.374-.578.136-1.02-.544-1.02h-3.91c-.442 0-.782.17-1.02.544l-4.386 6.842V29.05c0-.544-.306-.85-.85-.85h-3.4c-.544 0-.85.306-.85.85v22.1c0 .544.306.85.85.85h3.4c.544 0 .85-.306.85-.85v-6.606l4.726 6.912c.238.374.578.544 1.02.544h3.876c.68 0 .918-.442.51-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.562 40.1c0-.68.544-1.156 1.802-1.156.782 0 1.36.34 1.598.884.238.476.408.748.918.748h3.332c.544 0 .884-.306.816-.884-.408-3.604-3.502-5.168-6.664-5.168-3.57 0-6.902 1.734-6.902 5.576 0 6.596 8.874 4.352 8.874 6.8 0 .68-.544 1.156-1.972 1.156-1.02 0-1.666-.34-1.938-.918-.238-.442-.408-.714-.918-.714h-3.332c-.544 0-.884.306-.816.884.408 3.604 3.536 5.168 7.004 5.168 3.74 0 7.072-1.666 7.072-5.576 0-6.63-8.874-4.284-8.874-6.8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#sbpgz3wi8a)",
    xlinkHref: "#56dgue9x5b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#56dgue9x5b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.135 26.511c3.943 1.183 13.933-6.144 13.933-6.144s-8.115-2.792-16.23-3.12C-1.276 16.916.086 26.51.086 26.51s5.106-1.182 9.05 0z",
    fill: "url(#988okwrpxc)",
    transform: "translate(30.188 20.119)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.068 30.444S1.635 33.802.272 45.446c0 0-4.468-22.36 22.796-25.074v10.072z",
    fill: "url(#4qp7rrr7wd)",
    transform: "translate(30.188 20.119)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.307 0v10.67S5.27 11.459.303 26.64c0 0-5.568-24.921 31.004-26.64",
    fill: "url(#w6omsa2fie)",
    transform: "translate(30.188 20.119)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinbookLogoNew);
export default __webpack_public_path__ + "static/media/finbook-logo-new.381d2f594ead993f985f1727d914dc74.svg";
export { ForwardRef as ReactComponent };